import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { ModalService } from '../../../../../services/modal.service';
import { AlertService } from '../../../../../services/alert.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { IndicadoresService } from '../../../services/indicadores.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { ConstantsCatalogosIdService } from './../../../../../services/constants-catalogos-id.service';
import { PlanAccionService } from '../../../services/plan.accion.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ObjetivoService } from '../../../services/objetivo.service';

@Component({
  selector: 'app-indicadores-plan-accion',
  templateUrl: './indicadores-plan-accion.component.html',
  styleUrls: ['./indicadores-plan-accion.component.css']
})
export class IndicadoresPlanAccionComponent implements OnChanges {
  public formPlanAccionIndicadores: UntypedFormGroup;
  public submitted = false;
  public dataPlanAccionIndicadores: any = [];
  public dataPlanesAccion: any = [];
  public dataIndicadores: any[] = [];
  private idDeleteRegister: number = 0;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public nameModalPlan: string = 'PlanAccion-modalNewEdit'
  public nameApp = 'INDICADOR-PLAN ACCIÓN';
  public selectItems: any = [];
  public idSprAmbiente: number = 0;
  public nameModalConfigPlan: string = 'modalConfigPlan'
  public nameModalCumple: string = 'modalCumplePlan'
  public dataResponsableProceso: any = [];
  public dataElementosParticpantes: any = [];
  public dataEquipoGerencial!: any;
  public dataTipoParticpacion: any = [];
  public dataIndicadorSendConfigProyect: any[0] = [0];
  public descripcionIndicador !: any;
  public descripcionConfigIndicador !: any;
  public cumpleIndicadores = [];
  public nombrePlanAccion = [];
  public desripcionPlanAccion!: any;
  tipoParticipante: any;
  public dataCumpleIndicador: any[] = [];
  idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  public idResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;
  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;

  //Array que almacena los ids de los planes asociados al plan anual seleccionado
  public dataObjetivosPorAnio: any = null;

  public planAccion: any = null;
  public dataObjetivo!: any;
  private idSprPlanAnio: number = 0;
  public estadoActivo: number = 1;
  public idSprNivel: number = 0;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @Input() set init3(planAccion: any) {
    this.planAccion = planAccion;
    this.initApp(planAccion);
  }

  @Input() set idsObjetivos(dataObjetivosPorAnio: any) {
    this.dataObjetivosPorAnio = dataObjetivosPorAnio;
  }

  @Input() set planAnual(planAnioSeleccionadoRedux: any) {
    this.planAnioSeleccionadoRedux = planAnioSeleccionadoRedux;
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    public modal: ModalService,
    private indicadorService: IndicadoresService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private comunService: ComunService,
    private planAccionService: PlanAccionService,
    public store: Store<AppState>,
    private objetivoService: ObjetivoService,
    private participanteElementoService: ParticipanteElementoService,
    private equipoGerencialService: EquipoGerencialService,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe(response => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin
      this.getIpPublic();
      this.setFormPlanAccion();
    })
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ConfguracionObjetivoInit(obj: any) {
    this.desripcionPlanAccion = obj.nombrePlanAccion;

  }

  setFormPlanAccion(idSprPlanAccion: string = " ") {
    this.formPlanAccionIndicadores = this.fb.group({
      idSprPlanAccion: [idSprPlanAccion],
      idSprIndicador: [],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [],
      unidadInformacion: [],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      estado: ['', [Validators.required]],
    });
  }
  
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  ngOnChanges(): void {
    this.initApp(this.planAccion)
  }


  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  get appForm() {
    return this.formPlanAccionIndicadores.controls;
  }

  initApp(data: string = '') {
    if (data == 'planAccion') {
      this.store.select('globalApp').subscribe(response => {
        this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
        this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
        this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
        this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
        this.getDataObjetivos();
      })
      this.getDataObjetivos();
    }
  }

  getDataObjetivos() {
    forkJoin([
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprPlanAnio=${this.idSprPlanAnio}&estado=${this.estadoActivo}`),
      this.planAccionService.list('?estado=' + this.estadoActivo),
      this.indicadorService.list(),
      this.participanteElementoService.list('?estado=1'),
      this.equipoGerencialService.list('?idSprAmbiente=' + this.idSprAmbiente),
      this.comunService.list("?spr_idSprComun=" + this.idSprTipoParticipante)
    ]).pipe(map(
      ([objetivos, lineasAccion, indicadores, participaElemento, dataEquipoGerencial, respTipoParticipa]) => {
        this.dataObjetivo = objetivos;
        this.dataPlanesAccion = lineasAccion;
        this.dataIndicadores = indicadores;
        this.dataElementosParticpantes = participaElemento;
        this.dataEquipoGerencial = dataEquipoGerencial;
        this.dataTipoParticpacion = respTipoParticipa;
        this.mapeoLineasAccionIndicadores();
        //this.mapeoProcesosParticipante();
        this.mapeoEquipoGerencialTipoParticipa();
      })).subscribe();
  }

  mapeoLineasAccionIndicadores() {
    let dataProcess: any = [];
    let dataIndicador: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataPlanesAccion.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataPlanesAccion[j].idSprObjetivo) {
          for (let m = 0; m < this.dataIndicadores.length; m++) {
            if (this.dataIndicadores[m].idSprPlanAccion == this.dataPlanesAccion[j].idSprPlanAccion) {

              dataIndicador.push({
                idSprIndicador: this.dataIndicadores[m].idSprIndicador,
                idSprPlanAccion: this.dataIndicadores[m].idSprPlanAccion,
                nombre: this.dataIndicadores[m].nombre,
                descripcion: this.dataIndicadores[m].descripcion,
                unidadInformacion: this.dataIndicadores[m].unidadInformacion,
                fechaInicio: this.dataIndicadores[m].fechaInicio,
                estado: this.dataIndicadores[m].estado,
                idSprResponsable: this.dataIndicadores[m].idSprResponsable
              })
            }
          }
          dataProcess.push({
            idSprPlanAccion: this.dataPlanesAccion[j].idSprPlanAccion,
            nombrePlanAccion: this.dataPlanesAccion[j].nombre,
            descripcion: this.dataPlanesAccion[j].descripcion,
            alcance: this.dataPlanesAccion[j].alcance,
            localidadImpacto: this.dataPlanesAccion[j].localidadImpacto,
            justificacion: this.dataPlanesAccion[j].justificacion,
            fechaInicio: this.dataPlanesAccion[j].fechaInicio,
            fechaFin: this.dataPlanesAccion[j].fechaFin,
            indicadores: dataIndicador
          });
          dataIndicador = [];
        }
      }
    }
    this.dataPlanAccionIndicadores = dataProcess;
  }


  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if (this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun && this.dataEquipoGerencial[i].estado == 1 && this.dataEquipoGerencial[i].idSprTipoParticipante == this.idResponsable) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }

  
  onSubmit() {
    this.submitted = true;
    this.formPlanAccionIndicadores.value.usuario = this.currentUser.idSprUsuario;
    this.formPlanAccionIndicadores.value.ip = this.ipAddress;
    this.formPlanAccionIndicadores.value.idSprResponsable = this.formPlanAccionIndicadores.value.idSprEquipoGerencial;
    this.formPlanAccionIndicadores.value.nombre = this.formPlanAccionIndicadores.value.nombre;
    if (!this.formPlanAccionIndicadores.invalid) {
      if (this.formPlanAccionIndicadores.value.idSprIndicador == null) {
        this.indicadorService.create(this.formPlanAccionIndicadores.value).subscribe(
          (resp) => {
            this.closeModalConfiguracion();
            this.alert.createOk();
            this.initApp(this.planAccion);
          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.indicadorService.update(this.formPlanAccionIndicadores.value).subscribe(
          (resp) => {
            this.closeModalConfiguracion();
            this.alert.updateOk();
            this.initApp(this.planAccion);
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
      return;
    }
  }


  delete(row: any) {
    this.idDeleteRegister = row.idSprIndicador;
    this.modal.open('delete-planAccion');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.indicadorService.update({
        "idSprIndicador": this.idDeleteRegister,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.initApp(this.planAccion);
        this.alert.deleteOk();
        this.modal.close();
      }, (err) => {
        this.alert.deleteError();
        this.modal.close();
      });
    }
  }

  configuracionIndicador(obj: any) {
    this.setFormPlanAccion()
    this.descripcionIndicador = obj.nombre;
    this.dataIndicadorSendConfigProyect = obj;
    this.openModalConfigIndicadorPlan();
  }

  cumpleInit(obj: any) {
    this.descripcionConfigIndicador = obj.nombre;
    this.dataIndicadorSendConfigProyect = obj;
    this.openModalCumpleIndicadorPlan();
  }

  editConfigIndicador(obj: any, row) {
    this.nombrePlanAccion = row.nombrePlanAccion;
    this.onResetForm();
    this.setFormPlanAccion(obj.idSprPlanAccion)
    this.formPlanAccionIndicadores.patchValue({
      idSprIndicador: obj.idSprIndicador,
      idSprPlanAccion: obj.idSprPlanAccion,
      idSprEquipoGerencial: obj.idSprResponsable,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      unidadInformacion: obj.unidadInformacion,
      fechaInicio: obj.fechaInicio,
      estado: obj.estado,
    });
    this.modal.open(this.nameModalPlan);
  }


  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onResetForm() {
    this.submitted = false;
    this.formPlanAccionIndicadores.reset();
  }

  openModalPlan(row: any) {
    this.onResetForm();
    this.setFormPlanAccion(row.idSprPlanAccion);
    this.nombrePlanAccion = row.nombrePlanAccion;
    this.modal.open(this.nameModalPlan);
  }

  openModalConfigIndicadorPlan() {
    this.onResetForm();
    this.modal.open(this.nameModalConfigPlan);
  }
  openModalCumpleIndicadorPlan() {
    this.onResetForm();
    this.modal.open(this.nameModalCumple);
  }

  closeModalConfiguracion() {
    this.modal.closeId('PlanAccion-modalNewEdit');
    this.reDrawDataTable()
  }
}